var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3353 0H10.6833C4.78213 0 0 4.78416 0 10.6833C0 16.5844 4.78416 21.3665 10.6833 21.3665H19.3353C25.2364 21.3665 30.0186 16.5824 30.0186 10.6833C30.0186 4.78213 25.2364 0 19.3353 0Z",
    fill: "url(#paint0_linear_1753_15175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3351 0H10.6831C5.72661 0 1.55871 3.37526 0.352539 7.95467C5.90094 5.85654 9.84585 9.4406 15.299 7.44788C19.6108 5.87276 20.9467 2.49952 21.344 0.192583C20.6933 0.0668973 20.0223 0 19.3351 0Z",
    fill: "url(#paint1_linear_1753_15175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3657 25.9501C29.3779 25.938 29.386 25.9298 29.3962 25.9177H19.99C14.9423 25.9177 10.8474 21.8228 10.8474 16.771C10.8474 11.7213 14.9403 7.62842 19.99 7.62842C25.0397 7.62842 29.1346 11.7213 29.1346 16.771C29.1346 18.6989 28.5387 20.4869 27.521 21.9626L29.6414 25.6359C29.6475 25.6298 29.6516 25.6217 29.6556 25.6177L29.8523 25.9562L29.3657 25.9501Z",
    fill: "url(#paint2_linear_1753_15175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.425 8.81617C15.425 8.81617 18.0158 20.1643 27.5213 21.9625C30.8661 17.3141 28.5328 11.7556 25.9968 9.77705C22.4715 7.02819 18.5084 7.10117 15.425 8.81617Z",
    fill: "url(#paint3_linear_1753_15175)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0433 16.7524C16.619 16.7524 17.0873 17.2207 17.0873 17.7964C17.0873 18.3722 16.619 18.8404 16.0433 18.8404C15.4675 18.8404 14.9993 18.3722 14.9993 17.7964C15.0013 17.2207 15.4675 16.7524 16.0433 16.7524Z",
    fill: "#212333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5818 16.7524C25.1576 16.7524 25.6258 17.2207 25.6258 17.7964C25.6258 18.3722 25.1596 18.8404 24.5818 18.8404C24.0061 18.8404 23.5378 18.3722 23.5378 17.7964C23.5378 17.2207 24.0061 16.7524 24.5818 16.7524Z",
    fill: "#212333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3123 16.3105C21.1313 16.3105 21.7962 16.9755 21.7962 17.7965C21.7962 18.6155 21.1313 19.2824 20.3123 19.2824C19.4913 19.2824 18.8264 18.6175 18.8264 17.7965C18.8264 16.9755 19.4934 16.3105 20.3123 16.3105Z",
    fill: "#212333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1753_15175",
    x1: 15.0094,
    y1: 20.6381,
    x2: 15.0094,
    y2: -15.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08203F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#073562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#036ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0280DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1753_15175",
    x1: 19.6805,
    y1: 19.3909,
    x2: 8.74891,
    y2: 0.429885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09305F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0280DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1753_15175",
    x1: 13.5267,
    y1: 10.3071,
    x2: 29.5152,
    y2: 26.2956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9984,
    stopColor: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1753_15175",
    x1: 2.17644,
    y1: -7.15835,
    x2: 28.0476,
    y2: 18.7128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5612,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8404,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.2c730706e3124967561e4a7a1f79096f.svg";
export { ForwardRef as ReactComponent };